import { render, staticRenderFns } from "./CatalogContentAddUpdate.vue?vue&type=template&id=ade2c41a&scoped=true"
import script from "./CatalogContentAddUpdate.vue?vue&type=script&lang=js"
export * from "./CatalogContentAddUpdate.vue?vue&type=script&lang=js"
import style0 from "./CatalogContentAddUpdate.vue?vue&type=style&index=0&id=ade2c41a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ade2c41a",
  null
  
)

export default component.exports